import { DetailTabHeader } from 'common/components/DetailControls/DetailTabHeader';
import { MainContainerWrapper } from 'common/components/MainContainerWrapper/MainContainerWrapper';
import { MainTitle } from 'common/components/MainContainerWrapper/styles';
import { NestedTabs } from 'common/components/NestedTabs/NestedTabs';
import { FC, useEffect, useMemo } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { Constants } from 'utils/constants';
import { SubVarieties } from './Tabs/SubVarieties';
import { Rootstocks } from './Tabs/Rootstocks';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const TitleWrapper = styled(Wrapper)`
  margin-bottom: 20px;
`;

const TableWrapper = styled(Wrapper)`
  margin-top: 20px;
`;

export const VarietiesView: FC = () => {
  const { url } = useRouteMatch();
  const { pathname } = useLocation();
  const history = useHistory();

  useEffect(() => {
    const tabPath = pathname.substring(url.length);

    // Redirect to sub-varieties tab if accessing the page without a tab.
    if (tabPath === '') {
      history.replace(`${url}${Constants.routes.SUB_VAR}`);
    }
  }, [history, pathname, url]);

  const nestedTabs = useMemo(
    () => [
      {
        header: (isSelected: boolean) => (
          <DetailTabHeader isSelected={isSelected} tabName='Sub-Varieties' />
        ),
        view: () => (
          <TableWrapper>
            <SubVarieties />
          </TableWrapper>
        ),
        tabPath: Constants.routes.SUB_VAR,
      },
      {
        header: (isSelected: boolean) => (
          <DetailTabHeader isSelected={isSelected} tabName='Rootstocks' />
        ),
        view: () => (
          <TableWrapper>
            <Rootstocks />
          </TableWrapper>
        ),
        tabPath: Constants.routes.ROOTSTOCK,
      },
    ],
    [],
  );

  return (
    <MainContainerWrapper maxWidth='1100px' sidePadding={false}>
      <TitleWrapper>
        <MainTitle>Varieties Settings</MainTitle>
      </TitleWrapper>
      <NestedTabs tabs={nestedTabs} />
    </MainContainerWrapper>
  );
};
